module.exports = __webpack_public_path__ + "img/sdg_icon_17.bcaf7b19.png";